import { persistStateTypes } from '../../reducers/persistStateReducer';

import {
  GAME_ID,
  APP_PAGES,
  LOAD_PROGRESS_PAGE,
  LOAD_LEVEL_SUMMARY_PAGE,
  LOAD_ONBOARDING_PAGE,
  LOAD_STANDARD_PAGE,
  LOAD_INSTRUCTION_PAGE,
  LOAD_LOADING_PAGE,
  LOAD_PRACTICE_PAGE,
} from '../data/goblinGourmetConstants';

const initialState = {
  currentPage: APP_PAGES.LOADING,
  menuMode: false,
  onboardingMode: false,
  standardMode: false,
  instructionMode: false,
  practiceMode: false,
  onboardingForced: false,
};

// pretty straightforward: navigate through main pages
const goblinGourmetNavigationReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case LOAD_PROGRESS_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.PROGRESS,
        menuMode: true,
      };
    }
    case LOAD_LEVEL_SUMMARY_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.LEVEL_SUMMARY,
        menuMode: true,
      };
    }
    case LOAD_ONBOARDING_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.ONBOARDING,
        onboardingMode: true,
        onboardingForced: action.payload.onboardingForced,
      };
    }
    case LOAD_STANDARD_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.STANDARD,
        standardMode: true,
      };
    }
    case LOAD_INSTRUCTION_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.INSTRUCTION,
        instructionMode: true,
      };
    }
    case LOAD_LOADING_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.LOADING,
        menuMode: false,
      };
    }
    case LOAD_PRACTICE_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.PRACTICE,
        practiceMode: true,
      };
    }
    // Return to Progress Screen when gamestate call has been resolved
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...initialState,
        currentPage: APP_PAGES.PROGRESS,
        menuMode: true,
      };

    // Show Loading screen when gamestate request goes out
    case persistStateTypes.REQUEST_GAMESTATE:
      return {
        ...initialState,
        currentPage: APP_PAGES.LOADING,
      };
    default:
      return state;
  }
};

export default goblinGourmetNavigationReducer;
